export const SL_WEB_AUS_LAUNCH_MODAL = 'sl_web_aus_launch_modal';
export const SL_RATE_LIMITING_V3 = 'sl_rate_limiting_v3';
export const SL_WEB_CONDITION_VARIATION = 'SL_ios_web_spot_condition_colors';
export const SL_ALL_TIMESTAMP_UTC_OFFSETS = 'sl_all_timestamp_utc_offsets';
export const SL_IOS_WEB_NEARBY_BUOYS = 'sl_ios_web_nearby_buoys';
